module.exports = __webpack_public_path__ + "media/app/assets/races/dwarf_male-34159b12c6f73f1b39f42f53ccb2d20b.png";